module.exports = __webpack_public_path__ + "img/smartag2.f0f70056.png";